/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 */
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';
import reducers from './reducers';
import { muiTheme } from './theme';
import { getMenu } from './app.config';
import { Toolbar } from './components/layout';
import { Menu } from './modals';
import { getToken, getCurrentUser } from './security';
import { Login } from './containers';
import Store from './store';
import * as role from './security/role.validator';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

const store = new Store();

class App extends Component {
    render() {
        const { menu, userData } = this.props;
        return (
            <Provider store={store.create(reducers, { userData })}>
                <MuiThemeProvider muiTheme={muiTheme}>
                    <BrowserRouter>
                        <div>
                            <Toolbar />
                            <div className="mainContainer">
                                <Switch>
                                    {menu.map(item => <Route {...item} />)}
                                </Switch>
                            </div>
                            <Menu menu={menu} />
                        </div>
                    </BrowserRouter>
                </MuiThemeProvider>
            </Provider >
        );
    }
}

const isLoggedIn = getToken();

if (isLoggedIn) {
    const userData = getCurrentUser();
    getMenu(userData.permissions).then(menu => {
        render(
            <App {...{ userData, menu }} />,
            document.getElementById('app')
        );
    });
} else {
    render(
        <MuiThemeProvider muiTheme={muiTheme}>
            <Login />
        </MuiThemeProvider>,
        document.getElementById('app')
    );
}



// WEBPACK FOOTER //
// ./app.js